import { useTranslation } from 'react-i18next';
import CRUDSettings from '../components/General/CRUDSettings';
import { useCapacityTypes, useCreateCapacityType, useUpdateCapacityType } from '../hooks';

const CapacityTypes = () => {
    const { t } = useTranslation();
    const [capacityTypes] = useCapacityTypes();
    const { mutate: handleCreateCapacityType } = useCreateCapacityType();
    const { mutate: handleUpdateCapacityType } = useUpdateCapacityType();

    const columnDefs = [
        {
            field: 'name',
            headerName: t('field.capacityType'),
            editable: (params) => params.data.isRowEdited || params.data.isNewRecord,
        },
    ];

    return (
        <CRUDSettings
            tableRows={capacityTypes}
            columnDefs={columnDefs}
            btnText={t('capacity.addNewType')}
            createRecord={handleCreateCapacityType}
            updateRecord={handleUpdateCapacityType}
            recordType="Capacity Type"
        ></CRUDSettings>
    );
};

export default CapacityTypes;
